import * as React from 'react';

import { UitkTypeMargin, UitkTypeSize } from 'uitk-react-text/dist/types';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { UitkText } from 'uitk-react-text';

import { LodgingEnrichedMessageFragment, RatePlanFragment } from 'src/common/__generated__/api';

import EgdsMark = RatePlanFragment.EgdsMark;

export interface LodgingEnrichedMessageProps extends Omit<LodgingEnrichedMessageFragment.Fragment, '__typename'> {
  className?: string;
  size?: UitkTypeSize;
  spacing?: UitkTypeMargin;
  subTextClassName?: string;
  id?: string;
  egdsMark?: EgdsMark;
}

export const LodgingEnrichedMessage: React.FunctionComponent<LodgingEnrichedMessageProps> = ({
  className,
  size,
  subText,
  subTextClassName,
  value,
  theme,
  icon,
  mark,
  spacing,
  id,
  egdsMark,
}) => {
  if (!value) {
    return null;
  }

  const classNames = mappedClasses[theme] ? `${className} ${mappedClasses[theme]}` : `${className} pwa-theme--grey-700`;
  const weight = mappedWeight[theme] || 'regular';

  return (
    <>
      <UitkText className={classNames} size={size} weight={weight} spacing={spacing}>
        {icon?.id && (
          <UitkIcon name={icon.id} size={UitkIconSize.SMALL} className="all-r-margin-two" description={icon.description} id={id} />
        )}
        {mark?.id && !egdsMark?.url?.value && (
          <UitkMark name={mark.id} size={UitkMarkSize.SMALL} className="all-r-margin-two" description={mark.description} id={id} />
        )}
        {egdsMark?.url?.value && (
          <UitkMark
            url={egdsMark.url.value}
            size={UitkMarkSize.SMALL}
            className="all-r-margin-two"
            description={mark.description}
            id={id}
          />
        )}
        {value}
      </UitkText>
      {subText && <UitkText className={subTextClassName}>{subText}</UitkText>}
    </>
  );
};

export const mappedClasses = {
  AGGRESSIVE: 'pwa-theme--urgency',
  HIGHLIGHT: 'pwa-theme--success',
};

export const mappedWeight = {
  STRONG: 'bold',
};

LodgingEnrichedMessage.displayName = 'LodgingEnrichedMessage';
